import React, {FC, useEffect} from "react";
import facebookSvg from "images/Facebook.svg";
import twitterSvg from "images/Twitter.svg";
import googleSvg from "images/Google.svg";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import { Link } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/store";
import { useNavigate } from "react-router-dom";
import {login} from "../../app/authorizationReducers";
import AuthService from "../../app/services/authService";
import { toast } from "react-hot-toast";
import Notify from "components/Notify";
import { error } from "console";
import { Notification } from "app/helpers/sendnotification";
export interface PageLoginProps {
  className?: string;
}

const loginSocials = [
  {
    name: "Continue with Facebook",
    href: "#",
    icon: facebookSvg,
  },
  {
    name: "Continue with Twitter",
    href: "#",
    icon: twitterSvg,
  },
  {
    name: "Continue with Google",
    href: "#",
    icon: googleSvg,
  },
];

interface  User {
  avatar: string,
  email: string,
  firstname: string,
  lastname: string,
  username: string
}
export interface UserState {
  authChecked: false,
  loggedIn: false,
  token: "",
  user: User
}
const PageLogin: FC<PageLoginProps> = ({ className = "" }) => {

  const userLogin = useSelector<RootState, UserState>( (state: RootState) => state.authorizationReducer )
  const {loggedIn} = userLogin
  const navigate = useNavigate();
  useEffect(() => {
    if(loggedIn){
      navigate("/");
    }
  }, [loggedIn])

  const dispatch = useDispatch()
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    AuthService.login({email: e.target.elements.email.value, password: e.target.elements.password.value}).then( data =>{
   
      if(data.accessToken){
        dispatch(login(data))
        toast.custom((t) => (
          <Notify 
              t={t}
              message="Vous êtes maintenant connecté!"
              status ='success'
          />),
          { position: "top-right", id: "nc-product-notify", duration: 3000 }
        )
      }
      else{
        
      }
    }).catch(error =>{
      if(error.response.data.detail == 'not activate')
        Notification('warning', 'Vous devez activer votre compte')

      if(error.response.data.detail == 'Invalid credentials')
        Notification('warning', 'Email ou mot de passe incorrect!')
    })

  }
  return (
          <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
            <Helmet>
              <title>Roupa || Se connecter</title>
            </Helmet>
            <div className="container mb-24 lg:mb-32">
              <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
                Se connecter
              </h2>
              <div className="max-w-md mx-auto space-y-6">
                <div className="grid gap-3">
                  {/* {loginSocials.map((item, index) => (
                          <a
                            key={index}
                            href={item.href}
                            className="flex w-full rounded-lg bg-primary-50 dark:bg-neutral-800 px-4 py-3 transform transition-transform sm:px-6 hover:translate-y-[-2px]"
                            >
                            <img
                              className="flex-shrink-0"
                              src={item.icon}
                              alt={item.name}
                            />
                            <h3 className="flex-grow text-center text-sm font-medium text-neutral-700 dark:text-neutral-300 sm:text-sm">
                              {item.name}
                            </h3>
                          </a>
                          ))} */}
                </div>
                {/* OR */}
                {/* <div className="relative text-center">
                  <span className="relative z-10 inline-block px-4 font-medium text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">
                  OU
                  </span>
                  <div className="absolute left-0 w-full top-1/2 transform -translate-y-1/2 border border-neutral-100 dark:border-neutral-800"></div>
                </div> */}
                {/* FORM */}
                <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-6" >
                  <label className="block">
                    <span className="text-neutral-800 dark:text-neutral-200">
                      Adresse mail
                    </span>
                    <Input
                      type="email"
                      name="email"
                      placeholder="example@example.com"
                      className="mt-1"
                    />
                  </label>
                  <label className="block">
                    <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                      Mot de passe
                      <Link to="/forgot-pass" className="text-sm text-green-600">
                        Mot de passe oublié?
                      </Link>
                    </span>
                    <Input type="password" name="password" className="mt-1" />
                  </label>
                  <ButtonPrimary type="submit">Continue</ButtonPrimary>
                </form>

                {/* ==== */}
                <span className="block text-center text-neutral-700 dark:text-neutral-300">
                  Nouvel utilisateur? {` `}
                  <Link className="text-green-600" to="/signup">
                  Créer un compte
                  </Link>
                </span>
              </div>
            </div>
          </div>
          );
};

export default PageLogin;

